import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { AppStore, AppDispatch } from '../../store';
import { MaintenanceTable } from '../Layouts/DataTable';
import { useApiError } from '../../hooks';
import { EDataTableType, EModuleType, EApiType } from '../../data/Constants';
import { joinSelectedKeys } from '../../services/DataHelperFunctions';
import { deleteFeatureFlags, getFeatureFlags } from '../../store/states/FeatureFlagSlice';
import { setAlertMessage } from '../../store/states/AlertMessageSlice';

import type { IManagementProps } from '../../../types';

export const FeatureFlagsManagement = (props: IManagementProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const errorElement = useApiError(EApiType.FeatureFlagsKey);

  const deleteItems = (req) => {
    const featureFlags = AppStore.getState().featureFlags.featureFlags;
    dispatch(deleteFeatureFlags({ token: props.token, request: req })).then((res) => {
      const delKeys = joinSelectedKeys(req);
      if (res.payload?.data) {
        const message = t('messages.success.delete.featureFlags', {
          length: req.length,
          list: delKeys,
        });
        dispatch(setAlertMessage({ show: true, message: message, type: 'success' }));
        dispatch(
          getFeatureFlags({
            token: props.token,
            page: featureFlags.currentPage,
            limit: featureFlags.recordsPerPage,
            searchCode: featureFlags.searchKey,
            activeOnly: false,
          })
        );
      } else {
        const message = t('messages.fail.delete.featureFlags', {
          length: req.length,
          list: delKeys,
        });
        dispatch(setAlertMessage({ show: true, message: message, type: 'error' }));
      }
    });
  };

  if (errorElement) return errorElement;

  return (
    <>
      <h3 className="mainHeader"> {t('labels.featureFlagsManagement')}</h3>

      <MaintenanceTable
        token={props.token}
        type={EDataTableType.FeatureFlags}
        getDataList={getFeatureFlags}
        moduleType={EModuleType.FeatureFlags}
        deleteItems={deleteItems}
      />
    </>
  );
};
